// import { styles } from '@/common/style';
import React from 'react';
import { Image, Text, View, } from 'react-native';
import { styles } from '../../utils/style';
const Styles = {
    box: styles({
        alignItems: 'center',
        marginTop: 19,
    }),
    empty: styles({
        width: 96,
        height: 96,
    }),
    text: styles({
        fontSize: 14,
        lineHeight: 17,
        color: 'rgba(0, 0, 0, 0.4)',
        borderRadius: 8,
        textAlign: 'center',
        marginTop: 4,
    }),
    btn: styles({
        marginTop: 24,
    }),
};
export function Empty({ text, style, }) {
    return (React.createElement(View, { style: [Styles.box, style] },
        React.createElement(View, null,
            React.createElement(Image, { style: Styles.empty, source: {
                    uri: 'https://g-static.ap4r.com/kos/s101/nlav11312/shop-c-h5/empty.png',
                } })),
        React.isValidElement(text) ? (text) : (React.createElement(Text, { style: Styles.text }, text))));
}
export default Empty;
